module.exports = __webpack_public_path__ + "img/11-4.a94f3a60.jpg";